module.exports = __webpack_public_path__ + "static/media/eminence-asakusa-4.c223ae0b.jpg";